import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW1705Model } from './kymw1705.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { GetPastImageInfoResponse, GetPastImageInfoService } from './api-services/get-past-image-info.service';
import { RegistPastImageService } from './api-services/regist-past-image.service';

/**
 * 過去画像登録画面を管理するクラス
 *
 * @export KYMW1705Component
 * @class KYMW1705Component
 */
@Component({
  selector: 'app-kymw1705',
  templateUrl: 'kymw1705.component.html',
  styleUrls: ['kymw1705.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1705Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('txti_ImageFileName', { static: true }) txti_ImageFileName: ElementRef;
  public kymw1705Model: KYMW1705Model = new KYMW1705Model();

  /**
   * Creates an instance of KYMW1705Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetPastImageInfoService} getPastImageInfoService
   * @param {RegistPastImageService} registPastImageService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1705Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private getPastImageInfoService: GetPastImageInfoService,
    private registPastImageService: RegistPastImageService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * @memberof KYMW1705Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1705';
  }

  /**
   * 親画面から呼び出し元画像IDを呼び出す
   * @param imageId 
   */
  public setParameter(imageId: string): void {
    this.kymw1705Model.callerImageId = imageId;
  }

  /**
   * 表示
   * @memberof KYMW1705Component
   */
  public eventClickHandler_Display(): void {
    // 画像ファイル名の必須チェック・属性チェック
    const imageFileName = this.txti_ImageFileName.nativeElement.value;
    if (PlessViewUtilsSub.isEmpty(imageFileName)) {
      this.dialogService.openAlertGetMessage('W0001', ['画像ファイル名']);
      return;
    }
    this.getPastImageInfoService.execute(imageFileName, (data: GetPastImageInfoResponse) => {
      this.kymw1705Model.imageId = data.ImageId;
      this.kymw1705Model.imagePreviewUrl = data.ImagePreviewUrl
    });
  }

  /**
   * 画像サイズを設定
   * @memberof KYMW1705Component
   */
  public setImageScale():void {
    const img = document.getElementById('img_PastImage') as HTMLImageElement;
    
    if (img.naturalHeight < 650 && img.naturalWidth < 650) {
      // 画像を縦横どちらかは650にあわせる
      const ratio = img.naturalHeight / img.naturalWidth;
      // 横長画像のとき
      if ( img.naturalHeight < img.naturalWidth ) {
        img.width = 650;
        img.height = img.naturalWidth / ratio;
      } else {
        // 縦長画像のとき
        img.width = img.naturalHeight * ratio;
        img.height = 650;
      }
    }
  }

  /**
   * 登録
   * @memberof KYMW1705Component
   */
  public eventClickHandler_Register(): void {
    // 画像が未表示の場合、過去画像が表示されていない旨のメッセージを表示する
    if (PlessViewUtilsSub.isEmpty(this.kymw1705Model.imagePreviewUrl)) {
      this.dialogService.openAlertGetMessage('E0549');
      return;
    }
    // 過去画像登録API実行
    this.registPastImageService.execute(this.kymw1705Model.imageId, this.kymw1705Model.callerImageId, () => {
      this.dialogService.openAlertGetMessage('I0106', ['登録が完了']);
      this.eventClickHandler_Close();
    });
  }

  /**
   * 画面を閉じる
   * @memberof KYMW1705Component
   */
  public eventClickHandler_Close(): void {
    this.closeFunction();
  }

  /**
   * 画像ファイル名の入力から半角カンマを削除
   */
  public eventImageFileName_deleteCommaHandler(): void {
    this.txti_ImageFileName.nativeElement.value = this.txti_ImageFileName.nativeElement.value.replace(/,/g, '');
  }
}
